import React from 'react';
import { Link } from 'react-router-dom';

import AuctionsList from '@Components/Auction/AuctionsList';
import Col from '@Components/layout/Col';
import Row from '@Components/layout/Row';
import SearchItemsContentLoader from '@Components/Loaders/SearchItemsContentLoader';
import Typography from '@Components/Typography';
import { Messages } from '@Config/messages';
import { RouteConfig } from '@Config/routes';
import { useGetFeaturedAuctionsQuery } from '@Graphql/graphqlTypes.generated';
import { useTranslations } from '@Hooks/useTranslations';
import { GAAction, GACategory, sendGaEvent } from '@Utils/gaEvents';

import styles from './FeaturedAuctions.module.scss';

interface FeaturedAuctionsProps {
  itemsCount: number;
  onCompleted: () => void;
}

const FeaturedAuctions: React.FunctionComponent<FeaturedAuctionsProps> = ({ itemsCount, onCompleted }) => {
  const t = useTranslations();

  const { data, loading } = useGetFeaturedAuctionsQuery({
    variables: { amount: itemsCount },
    fetchPolicy: 'network-only',
    onCompleted,
  });

  const onFeaturedAuctionClick = () => {
    sendGaEvent({
      category: GACategory.featuredAuction,
      action: GAAction.click,
    });
  };

  const renderAuctions = () => {
    if (!data?.featuredAuctions?.length) {
      return <Typography msg={t(Messages.labelFeaturedAuctionsNoAuctions)} tag="span" />;
    }
    return (
      <>
        <AuctionsList onClick={onFeaturedAuctionClick} auctions={data?.featuredAuctions || []} />
        <Row size="size3">
          <Col size={3}>
            <Link to={RouteConfig.Auctions.buildLink()}>
              <Typography
                className={styles.moreLink}
                bold
                msg={t(Messages.labelSeeMoreAuctions)}
                tag="span"
                color="primary"
              />
            </Link>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <div className={styles.featuredItemContainer}>
      {loading ? <SearchItemsContentLoader count={itemsCount} gridSize={itemsCount} /> : renderAuctions()}
    </div>
  );
};

export default FeaturedAuctions;
